function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../../_snowpack/pkg/react.js';
import styled from '../../../_snowpack/pkg/styled-components.js';
import is from '../../../_snowpack/pkg/styled-is.js';
import { Field } from '../../../_snowpack/pkg/formik.js';
import { sizes } from '../sizes.js';
import { colors } from '../colors.js';
export * from './checkbox.js';
export * from './radio-button.js';
export * from './input.js';
export * from './price-input.js';
export * from './dropdown.js';
export * from './switch.js';
export { default as ShapeSwitch } from './shape-switch.js';
export * from './switch-with-label.js';
export * from './date-picker/index.js';
export const FormFields = styled.div.withConfig({
  displayName: "form__FormFields",
  componentId: "sc-1l4elwp-0"
})(["display:grid;grid-template-columns:", ";grid-row-gap:", ";grid-column-gap:", ";"], p => `repeat(${p.columns || 1}, 1fr)`, sizes.medium, sizes.medium);
export const FormFieldLabel = styled.label.withConfig({
  displayName: "form__FormFieldLabel",
  componentId: "sc-1l4elwp-1"
})(["display:block;line-height:1;font-size:12px;padding-bottom:2px;color:rgba(0,0,0,0.5);text-transform:uppercase;font-weight:600;", ";", ";"], p => p.paddingLeft && `padding-left: ${p.paddingLeft} !important`, p => p.marginBottom && `margin-bottom: ${p.marginBottom}`);
export const FieldGroupShadow = styled.span.withConfig({
  displayName: "form__FieldGroupShadow",
  componentId: "sc-1l4elwp-2"
})(["width:80%;position:absolute;bottom:0;left:10%;background:", ";height:20px;z-index:5;filter:blur(10px);opacity:0.15;"], colors.frostbite);
export const FormField = styled.div.withConfig({
  displayName: "form__FormField",
  componentId: "sc-1l4elwp-3"
})(["display:", ";align-items:center;position:relative;flex-direction:row-reverse;justify-content:flex-end;width:", ";", ";", "{padding:", ";", ";}"], p => p.checkbox ? 'flex' : 'block', p => p.width ? p.width : 'auto', is('span')`
    grid-column: span ${p => p.span};
  `, FormFieldLabel, p => p.checkbox && '0 0 0 10px', ''
/* margin-bottom: ${p => (p.checkbox ? 'flex' : 'block')};; */
);
export function withField(Cmp, name = '') {
  // eslint-disable-next-line react/display-name
  return ({
    namePrefix,
    fieldName,
    ...rest
  }) => {
    let finalName = namePrefix || fieldName || '';

    if (name) {
      if (finalName) {
        finalName = `${finalName}.${name}`;
      } else {
        finalName = name;
      }
    }

    return /*#__PURE__*/React.createElement(Field, {
      name: finalName
    }, fieldProps => /*#__PURE__*/React.createElement(Cmp, _extends({}, fieldProps, rest, {
      namePrefix: namePrefix,
      fieldName: fieldName
    })));
  };
}